
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import {
  ExamInfo,
  StructExam,
  StructExamUserData
} from "@/lib/model/exam/exam";
import ExamList from "@/lib/model/exam/exam";
import { ExamGetForm } from "@/lib/form/exam/ExamListForm";
import Auth from "@/lib/common/auth";
import _ from "lodash-es";
import { StructParam } from "@/lib/form/candidate/CandidateCreateForm";
import Editor from "@/components/editor/classic-editor.vue";
import ContactModal from "@/components/contact-modal.vue";
import ExamCreateForm, { ExamUpdateForm } from "@/lib/form/exam/ExamCreateForm";
import UploadImg from "@/components/UploadImg.vue";
import Breadcrumb from "@/components/layout/breadcrumb.vue";
import dayjs from "dayjs";
import PaperSteps from "@/components/exam/paper-steps.vue";
import ModalHeader from "@/components/modal-header.vue";
import ModalTitle from "@/lib/model/exam/modal-title";
import vuexStore from "@/store/vuex-store";

class TestExamList {
  id = 0;
  name = "";
  connectCode = "";
}

@Component({
  components: {
    Editor,
    ContactModal,
    UploadImg,
    Breadcrumb,
    PaperSteps,
    ModalHeader
  }
})
export default class PaperInfoSf extends Vue {
  name = "paper-info-sf";
  isDisabled = false;
  hasPaper = false;
  loading = false;
  isSetting = true; //面试设置面包屑标识
  settingForm: StructExam = new StructExam();
  examCreateForm: ExamCreateForm = new ExamCreateForm();
  examUpdateForm: ExamUpdateForm = new ExamUpdateForm();
  testExamList: TestExamList[] = new Array<TestExamList>();
  structExamUserData: StructExamUserData = new StructExamUserData();
  status = "";
  paperId = "0";
  examGetForm = new ExamGetForm();
  //考卷信息缓存Key
  InfoItemCachePrefiex = "EXAM_I";
  studentInfoForm = new StructParam();
  showEditInfoItem = false;
  editInfoIndex = -1;
  startTime = dayjs(new Date()).format("YYYY-MM-DD 10:00:00");
  endTime = new Date();
  defaultDate = new Date();
  defaultEndDate = new Date();
  paperStepType = "add";
  modalTitle = new ModalTitle();
  paperStepNum = 1;
  placeHolder1 = "例如面试预计所需时间、注意事项等";
  rules = this.structExamUserData.rules();
  studentRules = {
    name: [{ required: true, message: "请输入字段名称", trigger: "blur" }]
  };
  fixedFoot = true; //悬浮脚按钮
  sideCol = true; //侧边栏收起
  sideStatus = ""; //侧边栏状态

  @Watch("settingForm.closeUpdate")
  onSettingFormCloseUpdateChange(to: number) {
    this.isDisabled = this.settingForm.closeUpdate == 1;
    this.hasPaper =
      this.settingForm.closeUpdate == 1 || this.settingForm.closeUpdate == 2;
  }
  @Watch("side") //底部按钮位移动画
  sideChanged(n: boolean) {
    this.sideCol = n;
    this.sideStatus = n ? "in" : "out";
  }
  get side() {
    return vuexStore.sideIsCollapse;
  }

  mounted() {
    this.sideCol = JSON.parse(localStorage.getItem("isCollapse") || "true");
    //滚动监听
    this.$nextTick(() => {
      window.addEventListener("scroll", () => {
        this.handleScroll();
      });
    });
    this.handleScroll();
    this.defaultEndDate = new Date(
      this.defaultDate.setDate(this.defaultDate.getDate() + 1)
    );
    this.endTime = new Date(
      this.defaultDate.setDate(this.defaultDate.getDate() + 1)
    );
    if (this.$route.query.paperId) {
      this.status = String(this.$route.query.status) || "edit";
      this.paperId = String(this.$route.query.paperId);
      this.getExamInfo();
    } else {
      this.status = "add";
      this.getCache();
      this.getTestQuestionList();
    }
  }

  getTestQuestionList() {
    ExamList.getTestExams().then(res => {
      if (res.code === 0) {
        if (res.data.length) {
          this.testExamList = res.data;
          if (this.settingForm.testExamId === 0) {
            this.settingForm.testExamId = res.data[0].id;
          }
        }
      }
    });
  }

  getExamInfo() {
    if (parseInt(this.paperId) > 0) {
      this.examGetForm.examId = parseInt(this.paperId);
      this.examGetForm.companyId = parseInt(Auth.companyId);
      ExamList.examGet(this.examGetForm)
        .then(res => {
          this.settingForm = this.initPaper(res);
          this.startTime = res.beginTime;
          this.endTime = res.endTime;
        })
        .then(() => {
          this.getTestQuestionList();
        });
    }
  }

  initPaper(e: StructExam) {
    if (e.testExamId > 0) {
      e.testExam = 1;
    } else {
      e.testExam = 2;
    }
    if (e.noEnding === 1) {
      //长期有效
      e.endDate = "";
      e.endTime = "";
      e.endTiming = "";
      e.startDate = "";
      e.beginTime = "";
      e.startTiming = "";
    } else {
      e.startDate = e.beginTime.slice(0, 10);
      e.startTiming = e.beginTime.slice(11, 16);
      e.endDate = e.endTime.slice(0, 10);
      e.endTiming = e.endTime.slice(11, 16);
    }
    return e;
  }

  selectInfo() {
    this.saveCache();
  }

  saveCache() {
    //新增模式，需要对个人信息字段做缓存。提交成功后清除缓存
    if (this.status === "add")
      localStorage.setItem(
        this.InfoItemCachePrefiex,
        JSON.stringify(this.settingForm.paramList)
      );
  }

  clearCache() {
    //新增模式，需要对个人信息字段做缓存。提交成功后清除缓存
    localStorage.removeItem(this.InfoItemCachePrefiex);
  }

  getCache() {
    const getData = localStorage.getItem(this.InfoItemCachePrefiex);
    if (getData && parseInt(this.paperId) > 0) {
      const data = JSON.parse(getData);
      this.settingForm.paramList = data;
    } else {
      this.settingForm.paramList = [
        {
          name: "姓名",
          type: 0,
          isRequired: 1,
          isShow: 1,
          sort: 0
        },
        {
          name: "手机",
          type: 0,
          isRequired: 1,
          isShow: 1,
          sort: 0
        },
        {
          name: "邮箱",
          type: 1,
          isRequired: 1,
          isShow: 1,
          sort: 0
        },
        {
          name: "学校",
          type: 1,
          isRequired: 2,
          isShow: 0,
          sort: 0
        },
        {
          name: "专业",
          type: 1,
          isRequired: 2,
          isShow: 0,
          sort: 0
        },
        {
          name: "毕业年份",
          type: 1,
          isRequired: 2,
          isShow: 0,
          sort: 0
        },
        {
          name: "学历",
          type: 1,
          isRequired: 2,
          isShow: 0,
          sort: 0
        },
        {
          name: "职位",
          type: 1,
          isRequired: 2,
          isShow: 0,
          sort: 0
        }
      ];
    }
  }

  onEditInfoItem(index = -1, item: any) {
    if (!item) {
      this.studentInfoForm = {
        name: "",
        isRequired: 2,
        isShow: 1,
        type: 2,
        paramId: 0,
        inputType: "",
        sort: 0,
        extraData: "",
        value: ""
      };
    } else {
      this.studentInfoForm = _.cloneDeep(item);
    }
    this.editInfoIndex = index;
    if (this.studentInfoForm.name) {
      this.modalTitle.title = "编辑字段";
    } else {
      this.modalTitle.title = "新增字段";
    }

    this.modalTitle.hasDesc = false;
    this.showEditInfoItem = true;
  }

  handleNoticeClose() {
    this.showEditInfoItem = false;
  }

  submitEditInfoItem() {
    for (const index in this.settingForm.paramList) {
      console.log(
        "this.settingForm.paramList[index].name: ",
        this.settingForm.paramList[index].name
      );
      if (
        this.settingForm.paramList[index].name === this.studentInfoForm.name &&
        Number(this.editInfoIndex) !== Number(index)
      ) {
        this.$message.error("候选人信息名称重复");
        return;
      }
      if (this.studentInfoForm.name == "" || this.studentInfoForm.name == " ") {
        this.$message.error("候选人信息名称不能为空");
        return;
      }
      if (this.studentInfoForm.name.length > 120) {
        this.$message.error("候选人信息名称字数太多");
        return;
      }
    }
    if (this.editInfoIndex === -1) {
      //新增
      this.settingForm.paramList.push(this.studentInfoForm);
    } else {
      this.settingForm.paramList.splice(
        this.editInfoIndex,
        1,
        this.studentInfoForm
      );
    }
    this.showEditInfoItem = false;
    this.saveCache();
  }

  setNoEnding() {
    console.log("setNoEnding");
  }

  saveDesc() {
    console.log("saveDesc");
  }

  uploaded(attr: string, url: string) {
    if (attr === "examLogoUrl") {
      this.settingForm.examLogoUrl = url;
    } else if (attr === "publicityPageBgImgUrl") {
      this.settingForm.publicityPageBgImgUrl = url;
    }
  }

  cancel() {
    this.$router.push("/exam/paper-sf");
  }

  submitPaper() {
    // 开始时间
    if (!this.startTime && this.settingForm.noEnding !== 1) {
      this.$message.error(`请选择面试开始时间`);
      return;
    } else {
      this.settingForm.startDate = dayjs(this.startTime).format("YYYY-MM-DD");
      this.settingForm.startTiming = dayjs(this.startTime).format("HH:mm:ss");
    }
    // 结束时间
    if (!this.endTime && this.settingForm.noEnding !== 1) {
      this.$message.error(`请选择面试结束时间`);
      return;
    } else {
      this.settingForm.endDate = dayjs(this.endTime).format("YYYY-MM-DD");
      this.settingForm.endTiming = dayjs(this.endTime).format("HH:mm:ss");
    }
    if (parseInt(this.paperId) > 0) {
      this.updateRequest(this.settingForm);
    } else {
      this.createRequest(this.settingForm);
    }
  }

  updateRequest(settingForm: StructExam) {
    this.examUpdateForm.userId = parseInt(Auth.userId);
    this.examUpdateForm.companyId = parseInt(Auth.companyId);
    this.examUpdateForm.examId = parseInt(this.paperId);
    if (this.settingForm.name.length >= 64) {
      this.$message.error("面试名称过长");
      return;
    }
    const handleRes = this.handleParams(settingForm);
    if (handleRes) {
      this.examUpdateForm.assign(handleRes);
      // this.examUpdateForm.paramList = this.settingForm.paramList;
      this.examUpdateForm.paramList = handleRes.paramList;
      ExamList.examUpdate(this.examUpdateForm)
        .then(res => {
          if (res.code === 0) {
            this.$router.push(`exam/paper`);
          } else {
            this.$message.error("更新失败");
          }
        })
        .catch((catRes: any) => {
          console.log("catch err: ", catRes);
        });
    }
  }

  createRequest(settingForm: StructExam) {
    this.examCreateForm.userId = parseInt(Auth.userId);
    this.examCreateForm.companyId = parseInt(Auth.companyId);
    const handleRes = this.handleParams(settingForm);
    if (handleRes) {
      this.examCreateForm.assign(handleRes);
      const createParamList = new Array<StructParam>();
      this.settingForm.paramList.forEach((item, index) => {
        const createParam = new StructParam();
        createParam.name = item.name;
        createParam.type = item.type;
        createParam.isRequired = item.isRequired;
        createParam.isShow = item.isShow;
        createParamList.push(createParam);
      });
      this.examCreateForm.paramList = createParamList;
      ExamList.examCreate(this.examCreateForm).then(res => {
        console.log("examCreate res: ", res);
        this.clearCache();
        const paperId = res.data.examId;
        // this.$router.push(`/paper-edit?paperId=${paperId}&status=add&step=2`);
        this.$router.push(
          `/paper-bgcheck?paperId=${paperId}&status=add&step=2`
        );
      });
    }
  }

  handleParams(settingForm: StructExam) {
    const form = _.cloneDeep(settingForm);
    if (form.noEnding === 2) {
      if (form.startDate && form.startTiming) {
        form.beginTime =
          form.startDate + " " + form.startTiming.slice(0, 5) + ":00";
      } else {
        this.$message.error("请选择开始时间");
        return false;
      }
      if (form.endDate && form.endTiming) {
        form.endTime = form.endDate + " " + form.endTiming.slice(0, 5) + ":00";
      } else {
        this.$message.error("请选择截止时间");
        return false;
      }
    } else if (form.noEnding === 1) {
      //长期有效
      form.endDate = "2999-12-31";
      form.endTime = "2999-12-31 00:00:00";
      form.endTiming = "00:00";

      form.startDate = "2020-12-11";
      form.beginTime = "2020-12-11 00:00:00";
      form.startTiming = "00:00";
    }
    if (form.endTime < form.beginTime) {
      this.$message.error("面试有效期设置有误");
      return false;
    }
    if (form.testExam === 2) {
      form.testExamId = 0;
    } else if (!form.testExamId) {
      this.$message.error("模拟练习已开启，请选择一道题目");
      return false;
    }
    if (form.useAutoAudit === 1) {
      if (form.autoAuditRefuseScore > form.autoAuditPassScore) {
        this.$message.error(
          "自动评估：自动拒绝的分数必须小于或等于自动通过的分数"
        );
        return false;
      }
    }
    return form;
  }
  //判断某个原生DOM元素是否不在屏幕可见区内
  isElementNotInViewport(el: HTMLElement) {
    const rect = el?.getBoundingClientRect();
    return (
      rect?.top >=
        (window.innerHeight || document.documentElement.clientHeight) ||
      rect?.bottom <= 0
    );
  }
  // 滑动到底 固定底部
  handleScroll() {
    if (this.isElementNotInViewport(this.$refs.foot as HTMLElement)) {
      this.fixedFoot = true;
    } else {
      this.fixedFoot = false;
    }
  }
}
